export const formatCurrency = (amt) => {
    amt = (amt == null || isNaN(amt)) ? 0 : (+amt);

    return `\$${amt.toFixed(2)}`;
};